export enum TicketStatus {
  PLANNING = "PLANNING",
  PINNED = "PINNED",
  DESPATCHED = "DESPATCHED",
  ENROUTE = "ENROUTE",
  ARRIVED = "ARRIVED",
  STARTED = "STARTED",
  PAUSED = "PAUSED",
  COMPLETE = "COMPLETE"
}
